// Typelizer digest 34b23d1c8229a9e87f90ebf50a19f282
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** GET /educators/teachers/:teacher_id/feedback */
  show: (
    params: { teacherId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/educators/teachers/:teacher_id/feedback', params, options),
    method: 'get',
  }),
}
